/**
 * Shared utilities for {@link SubjectRow}, {@link SubjectCard} and {@link SubjectsDataTable}.
 */
import { SUBJECT_CYCLE_CONFIG, type SubjectFilters } from './subject-configs';
import type { Subject } from '@/types/subject.types';

/**
 * Returns the cycle config object for a subject's educationCycle, or null.
 * Shared between {@link SubjectCard} and {@link SubjectRow} to avoid duplicating the conditional lookup.
 */
export function getSubjectCycleConfig(
  subject: Subject,
): (typeof SUBJECT_CYCLE_CONFIG)[keyof typeof SUBJECT_CYCLE_CONFIG] | null {
  return subject.educationCycle ? (SUBJECT_CYCLE_CONFIG[subject.educationCycle] ?? null) : null;
}

/** Map UI filters + pagination to subject list params. */
export function toSubjectListParams(
  filters: SubjectFilters,
  page: number,
  pageSize: number,
): {
  page: number;
  pageSize: number;
  cycles?: SubjectFilters['cycles'];
  statuses?: SubjectFilters['statuses'];
  isCore?: boolean;
} {
  return {
    page,
    pageSize,
    cycles: filters.cycles.length > 0 ? filters.cycles : undefined,
    statuses: filters.statuses.length > 0 ? filters.statuses : undefined,
    isCore: filters.isCore ?? undefined,
  };
}

/** True when any cycle / status / core filter is set. */
export function hasSubjectActiveFilters(filters: SubjectFilters): boolean {
  return filters.cycles.length > 0 || filters.statuses.length > 0 || filters.isCore !== null;
}
